import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDate } from '../context/AppContext';
import { setNavigate } from '../utils/navigation';

const Header: React.FC = () => {

  const { userEmail, role, tool, logout,  } = useAppDate();

  const navigate = useNavigate();

  const handleLogout =  () => {    
    if (role !== 'csi') {
      navigate(`/?tool=${encodeURIComponent(tool)}`);
    } else {
      logout();
      navigate('/login');
    }
  }  
  
  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  

  return (
    <header className="fixed top-0 left-0 w-full bg-white border-b shadow-sm flex items-center justify-between px-6 py-3 z-50">
      <div  className="text-xl font-bold text-gray-800 cursor-pointer">{role !== 'csi' ? `${tool}  Live Agent`: 'Chat Portal'}</div>
      {!userEmail && <button
        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition"
        onClick={() => navigate('/login')}
      >
        Admin Login
      </button>}

      {role && <button
        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition"
        onClick={handleLogout}
      >
        Logout
      </button>}
    </header>
  );
};

export default Header; 